var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"bg-primary-140 p-2 px-10"},[_c('p',{staticClass:"text-gray-100"},[_vm._v("\n    Copyright © "+_vm._s(new Date().getFullYear())+" Summit Professional Education, LLC. All Rights Reserved.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }